export default __webpack_public_path__ + "static/media/icon-calc.94dfdc5c.svg";